import i18n from 'i18next'
import {initReactI18next} from 'react-i18next'
import Backend from 'i18next-xhr-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import enTranslation from './translations/en/translation.json'
import esTranslation from './translations/es/translation.json'
import jaTranslation from './translations/ja/translation.json'
import telTranslation from './translations/tel/translation.json'

i18n
  // load translation using xhr -> see /public/locales
  // learn more: https://github.com/i18next/i18next-xhr-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    interpolation: {escapeValue: false}, // React already does escaping
    lng: 'en',
    fallbackLng: 'en', // language to use
    resources: {
      en: {
        translation: enTranslation,
      },
      es: {
        translation: esTranslation,
      },
      ja: {
        translation: jaTranslation,
      },
      tel: {
        translation: telTranslation,
      },
    },
  })

export default i18n
